import type { QueryClient } from "@tanstack/react-query";

import type { Playbook } from "../types/playbooks.types";

import { playbooksQueryKeys } from "./queryKeyFactory";

export const savePlaybookToCaches = (queryClient: QueryClient, playbook: Playbook) => {
    queryClient.setQueryData<Playbook[]>(playbooksQueryKeys.all(), (playbooks) => {
        if (!playbooks) {
            return [playbook];
        }

        const exists = playbooks.some((item) => item.playbookId === playbook.playbookId);
        return exists
            ? playbooks.map((item) => (item.playbookId === playbook.playbookId ? playbook : item))
            : [...playbooks, playbook];
    });

    queryClient.setQueryData(playbooksQueryKeys.detail(playbook.playbookId), playbook);
};
